import { get as getCookie } from 'js-cookie';
import { Redirect } from '../types/Redirect';

export const transformSiteLocation = (oldSiteLocation: string): string => {
  switch (oldSiteLocation) {
    case 'DesktopFrontpage':
      return 'dfp';

    case 'MobileFrontpage':
      return 'mfp';

    case 'AfterSales':
      return 'asp';

    case 'BookingConfirmationMail':
      return 'bcm';

    case 'BookingSuccessPage':
      return 'bsp';

    case 'CRMEmail':
      return 'crmm';

    case 'AdDiscoveryPage':
      return 'adp';

    case 'AndroidHome':
      return 'ah';

    case 'AndroidTicketDetail':
      return 'atd';

    case 'AndroidTicketList':
      return 'atl';

    case 'IOSHome':
      return 'ih';

    case 'IOSTicketDetail':
      return 'itd';

    case 'IOSTicketList':
      return 'itl';

    default:
      return oldSiteLocation;
  }
};

// this tracking label is being used for the fallback deep links only
export function buildBookingComTrackingLabel(redirect: Redirect): string {
  const {
    payload: { currency, locale, passengerAges, returnDate, siteLocation },
    tld,
  } = redirect;

  const children = passengerAges.filter(({ age, max }) =>
    age != null ? age < 18 : max < 18,
  ).length;

  const adults = Math.max(1, passengerAges.length - children);

  const tripType = returnDate ? 'rt' : 'ow';
  const clientId = getCookie('_go_client_id') || '';
  const trackingLabelPieces = [
    'goeu',
    'null',
    'null',
    'null',
    'null',
    tripType,
    adults,
    children,
    'null',
    'null',
    transformSiteLocation(siteLocation),
    tld,
    locale,
    currency,
    'Other',
    'x',
    'other',
    'null',
    'null',
    'null',
    clientId,
  ];

  const trackingLabel = trackingLabelPieces.join('_');
  return trackingLabel;
}
